import InvestigationsList from "./InvestigationsList";
export default InvestigationsList;
